import { Form, FormikProps } from 'formik';
import { Typography } from '@mui/material';
import { FormValues } from './types';
import styles from './ReportModal.module.css';

type NotFullyDeliveredProps = FormikProps<FormValues> & {
	id: string;
};

export default function NotFullyDeliveredForm({ id }: NotFullyDeliveredProps) {
	return (
		<Form
			className={styles['report-form']}
			id={id}
		>
			<div className={styles['flex-row']}>
				<Typography
					variant='body2'
					sx={{ maxWidth: 460 }}
				>
					This report lists loads that have not been fully delivered within the last 90 days for the
					current terminal. No additional criteria are required; the report downloads as an Excel (.xlsx)
					file.
				</Typography>
			</div>
		</Form>
	);
}
